import { useEffect, useState } from 'react';

/**
 * Theo dõi `(min-width: {minWidthPx}px)` bằng `matchMedia`, cập nhật lại mỗi khi trình duyệt đổi
 * kích thước qua ngưỡng (sự kiện `change`) — khác với việc chỉ đọc một lần lúc gắn component.
 * Dùng để các khung donate trực tiếp bật/tắt kết nối SignalR đúng theo kích thước màn hình thật
 * tại mọi thời điểm, tránh mở song song 2 kết nối khi bố cục đổi cột sau khi hồ sơ tải xong.
 */
export const useMediaQuery = (minWidthPx: number): boolean => {
  const query = `(min-width: ${minWidthPx}px)`;
  const [matches, setMatches] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(query).matches
  );

  useEffect(() => {
    if (typeof window === 'undefined') return undefined;
    const mql = window.matchMedia(query);
    const onChange = () => setMatches(mql.matches);
    onChange();
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);

  return matches;
};
